import React, { ReactNode } from 'react';

interface ModePopupProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit?: () => void;
  mode: 'view' | 'edit' | 'delete' | string;
  title?: string;
  children: ReactNode;
}

const ModePopup: React.FC<ModePopupProps> = ({
  isOpen,
  onClose,
  onSubmit,
  mode,
  title = 'Popup',
  children,
}) => {
    console.log({isOpen})
  if (!isOpen) return null;

  const getModeColor = () => {
    switch (mode) {
      case 'view':
        return '#3498db';
      case 'edit':
        return '#f39c12';
      case 'delete':
        return '#e74c3c';
      default:
        return '#7f8c8d';
    }
  };

  return (
    <div style={styles.overlay}>
      <div style={{ ...styles.modal, borderTop: `6px solid ${getModeColor()}` }}>
        <div style={styles.header}>
          <h2>{title} ({mode})</h2>
          <button onClick={onClose} style={styles.closeButton}>×</button>
        </div>
        <div style={styles.body}>{children}</div>
        <div style={styles.footer}>
          {mode !== 'view' && (
            <button onClick={onSubmit} style={{ ...styles.submitButton, backgroundColor: getModeColor() }}>
              {mode === 'delete' ? 'Confirm Delete' : 'Submit'}
            </button>
          )}
          <button onClick={onClose} style={styles.cancelButton}>Cancel</button>
        </div>
      </div>
    </div>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  overlay: {
    position: 'fixed',
    top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    zIndex: 1000,
  },
  modal: {
    backgroundColor: '#fff',
    borderRadius: 8,
    width: '90%',
    maxWidth: 700,
    boxShadow: '0 5px 15px rgba(0,0,0,0.3)',
    padding: 20,
    position: 'relative',
  },
  header: {
    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
  },
  closeButton: {
    background: 'none', border: 'none', fontSize: 24, cursor: 'pointer',
  },
  body: {
    marginTop: 10,
  },
  footer: {
    marginTop: 20,
    display: 'flex', justifyContent: 'flex-end', gap: 10,
  },
  submitButton: {
    padding: '8px 16px',
    color: '#fff',
    border: 'none',
    borderRadius: 4,
    cursor: 'pointer',
  },
  cancelButton: {
    padding: '8px 16px',
    backgroundColor: '#bdc3c7',
    color: '#fff',
    border: 'none',
    borderRadius: 4,
    cursor: 'pointer',
  },
};

export default ModePopup;
